export const LEVERAGE = 'leverage';

export enum EnumUSTFormField {
  masterAccountId = 'masterAccountId',
  copyType = 'copyType',
  depositAmount = 'recommendedMinDepositAmount',
  lot = 'lot',
  commissionAccountId = 'commissionAccountId',
  commissionAccountLogin = 'commissionAccountLogin',
  isVisible = 'isVisible',
  initialDeposit = 'initialDeposit',
  investorId = 'investorId',
  makeMinDepositAmountRequired = 'makeMinDepositAmountRequired',
  leverage = LEVERAGE,
}

export enum EnumUTACopyTAMasterFormField {
  accountType = 'accountType',
  copyType = 'copyType',
  isVisible = 'isVisible',
  commissionAccountLogin = 'commissionAccountLogin',
  profitSharing = 'profitSharing',
  recommendedMinDepositAmount = 'recommendedMinDepositAmount',
  makeMinDepositAmountRequired = 'makeMinDepositAmountRequired',
  leverage = LEVERAGE,
}
